"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _config = require("./config");

var _depCheck = _interopRequireDefault(require("../../dep-check"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LunaType = _react["default"].forwardRef(function (props, ref) {
  (0, _depCheck["default"])([]);
  var children = props.children,
      typeSet = props.typeSet,
      secondary = props.secondary,
      component = props.component,
      className = props.className,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart,
      other = props.other,
      resetMargin = props.resetMargin;

  var throwError = function throwError(message) {
    throw message;
  };

  var getComponent = function getComponent() {
    return component || throwError('LunaType: must use component prop');
  };

  var getClassList = function getClassList() {
    var _classnames;

    var colors = _config.classes.colors,
        resetMarginClass = _config.classes.resetMarginClass;
    return (0, _classnames2["default"])((_classnames = {}, _defineProperty(_classnames, typeSet, typeSet || throwError('LunaType: must use typeSet prop')), _defineProperty(_classnames, colors.secondary, secondary), _defineProperty(_classnames, resetMarginClass, resetMargin), _classnames), className);
  };

  var Component = getComponent();
  return _react["default"].createElement(Component, _extends({}, other, {
    className: getClassList(),
    onBlur: onBlur,
    onClick: onClick,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onMouseDown: onMouseDown,
    onMouseLeave: onMouseLeave,
    onMouseUp: onMouseUp,
    onTouchEnd: onTouchEnd,
    onTouchMove: onTouchMove,
    onTouchStart: onTouchStart,
    ref: ref
  }), children);
});

var flatTypesets = [].concat(_toConsumableArray(Object.values(_config.LunaTypeSets.body)), _toConsumableArray(Object.values(_config.LunaTypeSets.header)), _toConsumableArray(Object.values(_config.LunaTypeSets.support)), _toConsumableArray(Object.values(_config.LunaTypeSets.data)));
LunaType.propTypes = {
  typeSet: _propTypes["default"].oneOf(flatTypesets).isRequired,
  component: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  secondary: _propTypes["default"].bool,
  onBlur: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func,
  onTouchEnd: _propTypes["default"].func,
  onTouchMove: _propTypes["default"].func,
  onTouchStart: _propTypes["default"].func,
  resetMargin: _propTypes["default"].bool
};
LunaType.defaultProps = {
  other: {}
};
LunaType.displayName = 'LunaType';
var _default = LunaType;
exports["default"] = _default;
